/*
 noPagination: Boolean
 */


angular.module('Directives')
    .directive('ngTable', function() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/table.html',
            replace: true,
            scope: {
                table: '=tableData'
            },
            controller: function($scope) {
                $scope.table.data = $scope.table ? $scope.table.data || [] : [];
                $scope.activeSortName = false;
                $scope.activeFilters = {};
                $scope.sortASC = false;
                $scope.checkedItems = [];
                $scope.templatesPath = '/templates/directives/intellectual-table/';

                $scope.itemsCounts = [5, 10, 15, 20, 25];

                $scope.onInitTable = function(params) {
                    $scope.table.onInitTable ?
                        $scope.table.onInitTable(params) :
                        false;
                };

                var updatedFiltersFields = false;

                $scope.paginationData = {};

                $scope.applyFiltersCallback = function (size) {
                    var requestData = {};
                    if ($scope.activeSortName) {
                        requestData['sort'] = [$scope.activeSortName];
                        if (!$scope.sortASC) {
                            requestData['sort'].push('desc');
                        }
                        requestData['sort'] = requestData['sort'].join(',');
                    }
                    if ($scope.paginationData.number - 1) {
                        requestData['page'] = $scope.paginationData.number - 1;
                    }
                    if (size || $scope.paginationData.size) {
                        requestData['size'] = size || $scope.paginationData.size;
                    }

                    /*sortASC: $scope.sortASC,
                     filters: $scope.activeFilters,*/

                    (updatedFiltersFields || size) && $scope.table.onApplyFilters ?
                        $scope.table.onApplyFilters(requestData) : false;
                    updatedFiltersFields = false;
                };
                $scope.applySort = function (sortName) {
                    if ($scope.activeSortName == sortName) {
                        $scope.activeSortName = $scope.sortASC ? sortName : false;
                        $scope.sortASC = !$scope.sortASC;
                    } else {
                        $scope.activeSortName = sortName;
                        $scope.sortASC = true;
                    }
                    updatedFiltersFields = true;
                    $scope.applyFiltersCallback();
                    /* updatedFiltersFields = true;
                     $scope.applyFiltersCallback();*/
                };
                $scope.updatedFilters = function () {
                    updatedFiltersFields = true;
                };

                $scope.toPage = function(page) {
                    if ((page < 1) || (page > $scope.paginationData.totalPages)) return;
                    $scope.paginationData.number = page;
                    updatedFiltersFields = true;
                    $scope.applyFiltersCallback();
                };


                $scope.setSize = function(size) {
                    if (
                        ($scope.paginationData.size >= $scope.paginationData.totalElements) &&
                        (size >= $scope.paginationData.totalElements)
                    ) {
                        $scope.paginationData.size = size;
                        return;
                    } else {
                        $scope.paginationData.size = size;
                    }
                    updatedFiltersFields = true;
                    $scope.applyFiltersCallback();
                };

                var viewFormatTemplate = function(item) {
                    return function(data) {
                        var value = data[item.viewName];
                        value = value === null ? 'null' : value;
                        switch (item.cellType) {
                            case 'array-links':
                                if (!angular.isArray(value)) {
                                    value = [value || typeof value];
                                }
                                break;
                            default:
                                value = value || typeof value;
                                break;
                        }
                        return value;
                    };
                };


                $scope.$watch('table.head', function (a) {
                    a.map(function (item) {
                        switch(item.filterType) {
                            case 'select':
                                item.filterOptions = angular.copy(item.filterOptions);
                                var disabledOption = {
                                    text: item.filterPlaceholder
                                };
                                item.filterOptions.unshift(disabledOption);
                                item.model = disabledOption;
                                break;

                            case 'date':
                                item.model = {
                                    from: '',
                                    to: ''
                                };
                                break;
                            default:
                                item.model = '';
                                break;
                        }

                        item.viewFormate = item.viewFormate || viewFormatTemplate(item);


                        if (!($scope.table.noTitles)) {
                            item.titleCellTemplate =
                                $scope.templatesPath + 'header-cells/cell' + ((item.noSort || $scope.table.noSort) ? '' : '-with-sort') + '.html';
                        }
                        if (!$scope.table.noFilters && !item.noFilter) {
                            item.filterCellTemplate =
                                $scope.templatesPath + 'filters-cells/' + (item.filterType || 'text') + '.html';
                        }
                        item.bodyCellTemplate = $scope.templatesPath + 'body-cells/' + (item.cellType || 'text') + '.html';
                    });
                });
                $scope.$watch('table.info', function (a) {
                    if (!a) return;
                    for (var k in $scope.table.info) {
                        var item = $scope.table.info[k];
                        if (k != 'content') {
                            $scope.paginationData[k] = angular.copy(item);
                        }
                    }
                    $scope.paginationData.number = $scope.paginationData.number + 1;
                    if ($scope.paginationData.sort) {
                        $scope.activeSortName = $scope.paginationData.sort[0].property;
                    }
                    $scope.sortASC = $scope.paginationData.sort ? $scope.paginationData.sort[0].direction == 'ASC' : false;
                });
            }
        }
    });


// WEBPACK FOOTER //
// ./js/directives/table.js